/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Columns_HashInputs */

const id_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const ms_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cincangan`)
};

const da_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const de_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const en_us2_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const es_es2_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const es_mx2_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const fil_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const fr_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const it_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const hu_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const nl_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const no_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const pl_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const pt_br2_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const pt_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const ro_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const fi_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hajautusarvo`)
};

const sv_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const vi_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const tr_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karma`)
};

const cs_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hash`)
};

const bg_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хеш`)
};

const ru_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хеш`)
};

const uk_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хеш`)
};

const ar_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التجزئة`)
};

const hi_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`हैश`)
};

const th_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แฮช`)
};

const ja_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ハッシュ`)
};

const zh_cn2_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`哈希`)
};

const zh_hant1_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`雜湊`)
};

const ko_builds_comparison_columns_hash = /** @type {(inputs: Builds_Comparison_Columns_HashInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`해시`)
};

/**
* | output |
* | --- |
* | "Hash" |
*
* @param {Builds_Comparison_Columns_HashInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_columns_hash = /** @type {((inputs?: Builds_Comparison_Columns_HashInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Columns_HashInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_columns_hash(inputs)
	if (locale === "ms") return ms_builds_comparison_columns_hash(inputs)
	if (locale === "da") return da_builds_comparison_columns_hash(inputs)
	if (locale === "de") return de_builds_comparison_columns_hash(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_columns_hash(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_columns_hash(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_columns_hash(inputs)
	if (locale === "fil") return fil_builds_comparison_columns_hash(inputs)
	if (locale === "fr") return fr_builds_comparison_columns_hash(inputs)
	if (locale === "it") return it_builds_comparison_columns_hash(inputs)
	if (locale === "hu") return hu_builds_comparison_columns_hash(inputs)
	if (locale === "nl") return nl_builds_comparison_columns_hash(inputs)
	if (locale === "no") return no_builds_comparison_columns_hash(inputs)
	if (locale === "pl") return pl_builds_comparison_columns_hash(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_columns_hash(inputs)
	if (locale === "pt") return pt_builds_comparison_columns_hash(inputs)
	if (locale === "ro") return ro_builds_comparison_columns_hash(inputs)
	if (locale === "fi") return fi_builds_comparison_columns_hash(inputs)
	if (locale === "sv") return sv_builds_comparison_columns_hash(inputs)
	if (locale === "vi") return vi_builds_comparison_columns_hash(inputs)
	if (locale === "tr") return tr_builds_comparison_columns_hash(inputs)
	if (locale === "cs") return cs_builds_comparison_columns_hash(inputs)
	if (locale === "bg") return bg_builds_comparison_columns_hash(inputs)
	if (locale === "ru") return ru_builds_comparison_columns_hash(inputs)
	if (locale === "uk") return uk_builds_comparison_columns_hash(inputs)
	if (locale === "ar") return ar_builds_comparison_columns_hash(inputs)
	if (locale === "hi") return hi_builds_comparison_columns_hash(inputs)
	if (locale === "th") return th_builds_comparison_columns_hash(inputs)
	if (locale === "ja") return ja_builds_comparison_columns_hash(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_columns_hash(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_columns_hash(inputs)
	return ko_builds_comparison_columns_hash(inputs)
});
export { builds_comparison_columns_hash as "builds.comparison.columns.hash" }